// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Text_wrapper__5UVJZ","content":"Text_content__fSJfJ","narrowContent":"Text_narrowContent__qnRAq"};